/* istanbul ignore file */
import { Injectable } from '@angular/core';

@Injectable()
export class MockWindowRef {
  get nativeWindow(): any {
    return {
      sessionStorage: {
        getItem: function () {
          return '';
        },
        setItem: () => null,
        removeItem: () => null,
      },
      location: {
        hostname: '',
        href: '',
        reload: () => null,
      },
      open: () => null,
    };
  }
}
